import React from 'react';
import { cn } from '../../lib/cn';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  label?: string;
}

const sizes: Record<NonNullable<SpinnerProps['size']>, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-9 w-9 border-[3px]',
};

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', className, label }) => (
  <span
    role="status"
    aria-label={label || 'Carregando'}
    className={cn(
      'inline-block animate-spin rounded-full border-border-strong border-t-brand',
      sizes[size],
      className
    )}
  />
);

export const LoadingScreen: React.FC<{ message?: string }> = ({ message = 'Carregando...' }) => (
  <div className="flex h-screen w-full flex-col items-center justify-center gap-4 bg-background">
    <Spinner size="lg" />
    <p className="text-sm text-foreground-muted">{message}</p>
  </div>
);
